/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Line_Forward_Aria_LabelInputs */

const en_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shift Line Down`)
};

const fr_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler la Ligne en Bas`)
};

const de_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schichtleitung nach unten`)
};

const it_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sposta la linea verso il basso`)
};

const ru_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сдвиг линии вниз`)
};

const es_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazar línea hacia abajo`)
};

const zh_cn2_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`换线向下`)
};

const ja_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シフトラインダウン`)
};

const hi_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइन को नीचे खिसकाएँ`)
};

const pt_pt2_shift_line_forward_aria_label = /** @type {(inputs: Shift_Line_Forward_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linha de mudança para baixo`)
};

/**
* | output |
* | --- |
* | "Shift Line Down" |
*
* @param {Shift_Line_Forward_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_line_forward_aria_label = /** @type {((inputs?: Shift_Line_Forward_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Line_Forward_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shift_line_forward_aria_label(inputs)
	if (locale === "de") return de_shift_line_forward_aria_label(inputs)
	if (locale === "it") return it_shift_line_forward_aria_label(inputs)
	if (locale === "ru") return ru_shift_line_forward_aria_label(inputs)
	if (locale === "es") return es_shift_line_forward_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_shift_line_forward_aria_label(inputs)
	if (locale === "ja") return ja_shift_line_forward_aria_label(inputs)
	if (locale === "hi") return hi_shift_line_forward_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shift_line_forward_aria_label(inputs)
	return en_shift_line_forward_aria_label(inputs)
});